import {
  SecaoDaIntegracaoNaUrl,
  TipoDeModalAcoesDocumento,
  TipoDeSecaoAcoesDocumento,
} from '@/enums'
import type { Rota } from '@/models'

export const CADASTROS_ROTAS = {
  integracao: '/app/cadastros/configuracoes-papel-zero',
}

export const DOCUMENTO_ROTAS = {
  documento: (id: string) => `/app/documento/${id}`,
  baixar: (id: string) => `/app/documento/${id}/baixar`,
  assinar: (id: string) => `/app/documento/${id}/assinar`,
  compartilhar: (id: string) => `/app/documento/${id}/compartilhar`,
  historico: (id: string) => `/app/documento/${id}/historico`,
  integrar: (id: string, secao?: SecaoDaIntegracaoNaUrl) =>
    secao
      ? `/app/documento/${id}/integrar/${secao}`
      : `/app/documento/${id}/integrar`,
}

export const obterRotaDeMenuItemCadastros = (
  integracaoPapelZeroHabilitada: boolean,
  parametrizar?: boolean
) => {
  if (!integracaoPapelZeroHabilitada) return null
  if (parametrizar) return CADASTROS_ROTAS.integracao
  return null
}

const MENSAGEM_SEM_PERMISSAO_NA_CONFIGURACAO =
  'Você não tem permissão para acessar esta configuração.'

const rotaConfiguracoes: Rota = {
  path: 'configuracoes',
  filhas: [
    {
      index: true,
      pagina: 'Configuracoes',
      titulo: 'Configurações',
      permissoes: ['admin'],
      mensagemSemPermissao: MENSAGEM_SEM_PERMISSAO_NA_CONFIGURACAO,
    },
    {
      path: 'grupos',
      pagina: 'Configuracoes/pages/Grupos',
      titulo: 'Grupos',
      permissoes: ['admin'],
      mensagemSemPermissao: MENSAGEM_SEM_PERMISSAO_NA_CONFIGURACAO,
    },
  ],
}

const rotaCadastros: Rota = {
  path: 'cadastros',
  filhas: [
    {
      index: true,
      pagina: 'Cadastros',
      titulo: 'Cadastros',
      permissoes: ['permissao_para_parametrizar_campos_da_integracao'],
      mensagemSemPermissao: MENSAGEM_SEM_PERMISSAO_NA_CONFIGURACAO,
    },
    {
      path: 'configuracoes-papel-zero',
      pagina: 'Cadastros/pages/DadosParaEnvioAoPapelZero',
      titulo: 'Dados para envio ao Papel Zero',
      permissoes: ['permissao_para_parametrizar_campos_da_integracao'],
      mensagemSemPermissao: MENSAGEM_SEM_PERMISSAO_NA_CONFIGURACAO,
    },
  ],
}

export function obterRotas(integracaoPapelZeroHabilitada: boolean): Rota[] {
  return [
    { path: '/', pagina: 'Home' },
    {
      path: '/publico',
      filhas: [
        { index: true, redirecionarPara: 'documentos' },
        {
          path: 'documentos',
          pagina: 'ConsultarDocumentosPublicos',
          titulo: 'Consulta de documento público',
        },
        {
          layout: 'publico',
          filhas: [
            {
              path: 'documentos/:token',
              pagina: 'Documento',
              titulo: 'Consulta Pública',
              props: { publico: true },
            },
          ],
        },
      ],
    },
    {
      path: '/app',
      layout: 'app',
      filhas: [
        { index: true, redirecionarPara: 'documentos' },
        { path: 'documentos', pagina: 'Documentos', titulo: 'Documentos' },
        { path: 'documento/:id', pagina: 'Documento' },
        {
          path: 'documento/:id/baixar',
          pagina: 'Documento',
          props: { secaoInicial: TipoDeSecaoAcoesDocumento.BAIXAR },
        },
        {
          path: 'documento/:id/assinar',
          pagina: 'Documento',
          props: { secaoInicial: TipoDeSecaoAcoesDocumento.ASSINAR },
        },
        {
          path: 'documento/:id/compartilhar',
          pagina: 'Documento',
          props: { modalInicial: TipoDeModalAcoesDocumento.COMPARTILHAR },
        },
        {
          path: 'documento/:id/historico',
          pagina: 'Documento',
          props: { modalInicial: TipoDeModalAcoesDocumento.HISTORICO },
        },
        {
          path: 'documento/:id/integrar',
          pagina: 'Documento',
          props: {
            secaoInicial: TipoDeSecaoAcoesDocumento.ENVIAR_AO_PAPEL_ZERO,
          },
        },
        {
          path: `documento/:id/integrar/${SecaoDaIntegracaoNaUrl.INFORMACOES}`,
          pagina: 'Documento',
          props: {
            secaoInicial:
              TipoDeSecaoAcoesDocumento.CRIAR_PROCESSO_NO_PAPEL_ZERO,
          },
        },
        {
          path: `documento/:id/integrar/${SecaoDaIntegracaoNaUrl.COLABORADORES}`,
          pagina: 'Documento',
          props: {
            secaoInicial: TipoDeSecaoAcoesDocumento.COLABORADORES_DO_PROCESSO,
          },
        },
        {
          path: `documento/:id/integrar/${SecaoDaIntegracaoNaUrl.FINALIZAR}`,
          pagina: 'Documento',
          props: {
            secaoInicial: TipoDeSecaoAcoesDocumento.ENVIAR_AO_PAPEL_ZERO,
            modalInicial:
              TipoDeModalAcoesDocumento.FINALIZAR_ENVIO_AO_PAPEL_ZERO,
          },
        },
        rotaConfiguracoes,
        ...(integracaoPapelZeroHabilitada ? [rotaCadastros] : []),
      ],
    },
  ]
}
